<app-fechar-os 
titulo="Validar OS" 
[tipoAcaoOS]="3"></app-fechar-os>
